module.exports = __webpack_public_path__ + "static/media/icons-ic-notifications-accept.52242fde.svg";